import { useState } from 'react';
import { useTaskStore } from '@/lib/task-store';
import { KanbanColumn } from './kanban-column';
import { DragDropContext, DropResult } from '@hello-pangea/dnd';
import type { Task, TaskStatus } from '@/lib/types';

interface KanbanBoardProps {
  tasks: Task[];
}

export function KanbanBoard({ tasks }: KanbanBoardProps) {
  const { updateTask } = useTaskStore();

  const handleDragEnd = async (result: DropResult) => {
    const { destination, source, draggableId } = result;

    if (!destination) return;

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const newStatus = destination.droppableId as TaskStatus;
    await updateTask(draggableId, { status: newStatus });
  };

  const columns: TaskStatus[] = ['Open', 'Active', 'Hold', 'Closed'];
  const getColumnTasks = (status: TaskStatus) => 
    tasks.filter(task => task.status === status);

  return (
    <div className="space-y-6">      
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {columns.map(status => (
            <KanbanColumn
              key={status}
              status={status}
              tasks={getColumnTasks(status)}
            />
          ))}
        </div>
      </DragDropContext>
    </div>
  );
}